import { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';


export function Carousel({ slides }) {
    const [currentSlide, setCurrentSlide] = useState(0)

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides?.length)
        }, 5000)
        return () => clearInterval(timer)
    }, [])

    return (
        <div className="relative overflow-hidden rounded-lg md:h-[400px]">
            <div
                className="flex transition-transform duration-500 ease-out"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
                {slides.map((slide) => (
                    <div key={slide.id} className="w-full flex-shrink-0">
                        <img
                            src={slide.image}
                            alt={slide.title}
                            className="w-full object-cover"
                        />
                    </div>
                ))}
            </div>
            <button
                onClick={() => setCurrentSlide((prev) => (prev - 1 + slides?.length) % slides?.length)}
                className="absolute left-2 top-1/2 -translate-y-1/2 p-2 bg-black/50 rounded-full text-white"
            >
                <ChevronLeft className="h-6 w-6" />
            </button>
            <button
                onClick={() => setCurrentSlide((prev) => (prev + 1) % slides?.length)}
                className="absolute right-2 top-1/2 -translate-y-1/2 p-2 bg-black/50 rounded-full text-white"
            >
                <ChevronRight className="h-6 w-6" />
            </button>
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
                {slides.map((_, index) => (
                    <button
                        key={index}
                        className={`w-2 h-2 rounded-full ${index === currentSlide ? 'bg-white' : 'bg-white/50'
                            }`}
                        onClick={() => setCurrentSlide(index)}
                    />
                ))}
            </div>
        </div>
    )
}

